import { render, staticRenderFns } from "./requests.vue?vue&type=template&id=b50f0234"
import script from "./requests.vue?vue&type=script&lang=js"
export * from "./requests.vue?vue&type=script&lang=js"
import style0 from "./requests.vue?vue&type=style&index=0&id=b50f0234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports